<template>
    <form v-if="userInfo" ref="form" class="profile">
        <h1>Профиль</h1>
        <div class="profile_photo_wrap">
            <img class="profile_photo" :src="getPhotoUrl()" />
            <input ref="photo_input" type="file" accept="image/*" class="hidden" @change="uploadPhoto($event)">
            <v-btn @click="selectPhoto" :loading="loadingPhoto" class="photo_btn upload_btn">Загрузить</v-btn>
            <v-btn v-if="userInfo.logoUrl" @click="deletePhoto" :loading="loadingPhoto" class="photo_btn delete_btn">Удалить</v-btn>
        </div>
        <div class="profile_name_wrap">
            <div class="profile_fname">
                <label for="teacher_fname" class="profile_label">Фамилия</label>
                <input class="profile_name-text" type="text" name="teacher_fname" id="teacher_fname" placeholder="Введите текст" v-model="userInfo.fname">
            </div>
            <div class="profile_iname">
                <label for="teacher_iname" class="profile_label">Имя</label>
                <input class="profile_name-text" type="text" name="teacher_iname" id="teacher_iname" placeholder="Введите текст" v-model="userInfo.iname">
            </div>
            <div class="profile_oname">
                <label for="teacher_oname" class="profile_label">Отчество</label>
                <input class="profile_name-text" type="text" name="teacher_oname" id="teacher_oname" placeholder="Введите текст" v-model="userInfo.oname">
            </div>
        </div>
        <div class="profile_email_wrap">
            <div class="profile_loin">
                <label for="login">Логин</label>
                <input type="text" name="login" id="login" placeholder="Введите текст" v-model="userInfo.login" required>
            </div>
            <div class="profile_email">
                <label for="email">E-mail</label>
                <input type="email" name="email" id="email" placeholder="Введите текст" v-model="userInfo.email">
            </div>
        </div>
        <div class="profile_org-wrap">
            <p>Организация</p>
            <v-autocomplete
                label=""
                :items="organizations.list"
                hide-details
                item-value="id"
                item-text="name"
                outlined
                v-model="checkUserInfo.organizationIds"
                disabled
                :loading="organizations.list === null"
                :search-input.sync="organizations.searchInput"
                @change="organizations.searchInput = ''"
                clearable
                :multiple="userRoles !== 'Student'"
            ></v-autocomplete>
        </div>
        <div class="profile_org-wrap" v-if="userRoles !== 'Student'">
            <p>Специальность</p>
            <v-autocomplete
                label=""
                :items="specialities.list"
                hide-details
                item-value="id"
                item-text="name"
                outlined
                v-model="checkUserInfo.specialityIds"
                :disabled="specialities.list === null"
                :loading="specialities.list === null"
                :search-input.sync="specialities.searchInput"
                @change="specialities.searchInput = ''"
                clearable
                multiple
            ></v-autocomplete>
            <!-- <div class="profile_org-icon-spec">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41073 14.5118L3.57739 8.67851L4.7559 7.5L9.99998 12.7441L15.2441 7.5L16.4226 8.67851L10.5892 14.5118C10.2638 14.8373 9.73616 14.8373 9.41073 14.5118Z" fill="black"/>
                </svg>
            </div> -->
        </div>
        <div class="profile_org-wrap" v-if="userRoles !== 'Metodist'">
            <p>Курс</p>
            <v-autocomplete
                label=""
                hide-details
                :items="studyCourseList"
                :disabled="userRoles !== 'Metodist'"
                item-value="id"
                item-text="name"
                outlined
                :multiple="userRoles === 'Teacher'"
                v-model="checkUserInfo.studyCourseIds"
                clearable
            ></v-autocomplete>
        </div>
        <div class="profile_org-wrap" v-if="userRoles !== 'Metodist'">
            <p>Факультет</p>
            <v-autocomplete
                label=""
                :items="faculty.list"
                hide-details
                item-value="id"
                item-text="name"
                outlined
                v-model="checkUserInfo.facultyIds"
                disabled
                :loading="faculty.list === null"
                :search-input.sync="faculty.searchInput"
                @change="studyGroups.searchInput = ''"
                :multiple="userRoles !== 'Student'"
            ></v-autocomplete>
        </div>
        <div class="profile_org-wrap" v-if="userRoles !== 'Metodist'">
            <p>Учебные группы</p>
            <v-autocomplete
                label=""
                :items="studyGroups.list"
                hide-details
                item-value="id"
                item-text="name"
                outlined
                v-model="checkUserInfo.studyGroupIds"
                :disabled="studyGroups.list === null || userRoles !== 'Metodist'"
                :loading="studyGroups.list === null"
                :search-input.sync="studyGroups.searchInput"
                @change="studyGroups.searchInput = ''"
                clearable
                :multiple="userRoles !== 'Student'"
            ></v-autocomplete>
        </div>
        <div class="profile_btn-wrap">
            <v-btn @click="save" :loading="loading">Сохранить</v-btn>
        </div>
        <TimeoutSnackbar :options="snackbar" />
    </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import './index.scss';

export default {
    components: { TimeoutSnackbar },
    data() {
        return {
            organizations: {
                list: null,
                searchInput: ''
            },
            studyCourseList:[],
            specialities: {
                list: null,
                searchInput: ''
            },
            faculty: {
                list: null,
                searchInput: ''
            },
            studyGroups: {
                list: null,
                searchInput: ''
            },
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            loading: false,
            loadingPhoto: false
        }
    },
    computed: {
		...mapGetters({
            apiUrl: 'apiUrl',
            apiGuide: 'apiGuide',
			apiImg: "apiImg",
			userInfo: "user/userInfo",
			userRoles: "login/userRoles"
		}),
        checkUserInfo() {
            if(this.userRoles == 'Student') {
                if(Array.isArray(this.userInfo.organizationIds)) this.userInfo.organizationIds = this.userInfo.organizationIds[0]
                if(Array.isArray(this.userInfo.studyGroupIds)) this.userInfo.studyGroupIds = this.userInfo.studyGroupIds[0]
                if(Array.isArray(this.userInfo.studyCourseIds)) this.userInfo.studyCourseIds = this.userInfo.studyCourseIds[0]
                if(Array.isArray(this.userInfo.facultyIds)) this.userInfo.facultyIds = this.userInfo.facultyIds[0]
            }

            return this.userInfo
        }
    },
    methods: {
        ...mapActions({
			getUserInfo: "user/getUserInfo",
            uploadLogo: "user/uploadLogo"
		}),
        loadLookups() {
            this.$http.get(`${this.apiGuide}api/SprOrganization/GetAll`)
                .then((result) => {
                    this.organizations.list = result.data;
            });

            this.$http.get(`${this.apiGuide}api/SprSpeciality/GetAll`)
                .then((result) => {
                    this.specialities.list = result.data;
            });

            this.$http.get(`${this.apiUrl}api/SprStudyGroup/GetAll`)
                .then((result) => {
                    this.studyGroups.list = result.data;
            });
            this.$http.get(`${this.apiUrl}api/SprFaculty/GetAll`)
                .then((result) => {
                    this.faculty.list = result.data;
            });
        },
        getPhotoUrl() {
            if (this.userInfo.logoUrl) {
                return `${this.apiImg}${this.userInfo.logoUrl}`;
            }

            return require('@/assets/img/default-profile-image.png');
        },
        selectPhoto() {
            this.$refs.photo_input.click();
        },
        uploadPhoto(event) {
            this.uploadLogo(event).then(result => {
                if (result) {
                    this.userInfo.logoUrl = result.data;
                    this.updatePhoto();
                }
            });
        },
        deletePhoto() {
            this.userInfo.logoUrl = null;
            this.updatePhoto();
        },
        updatePhoto() {
            this.loadingPhoto = true;

            this.$http.post(`${this.apiUrl}User/UpdateLogo`, this.userInfo)
                .then(() => {
                    this.loadingPhoto = false;
                }, () => {
                    this.loadingPhoto = false;

                    this.snackbar = {
                        text: 'Произошла ошибка. Данные не были сохранены.',
                        color: 'error',
                        timeout: -1,
                        show: true
                    };
                });
        },
        save() {
            let form = this.$refs.form;

            let requiredInputs = form.querySelectorAll('[required]');
            requiredInputs.forEach(x => this.validateInput(x));

            let emailInput = form.querySelector('#email');
            this.validateEmail(emailInput);

            form.reportValidity();

            if (!form.checkValidity()) {
                return false;
            }

            this.loading = true;
            let urlGuide = {
                'Teacher': 'UpdateTeacher',
                'Student': 'UpdateStudent',
                'Metodist': 'UpdateMetodist'
            }

            this.$http.post(`${this.apiUrl}User/${urlGuide[this.userRoles]}`, {
                ...this.userInfo,
                organizationIds: this.userRoles == 'Student' ? [this.userInfo.organizationIds] : this.userInfo.organizationIds,
                studyGroupIds: this.userRoles == 'Student' ? [this.userInfo.studyGroupIds] : this.userInfo.studyGroupIds,
                facultyIds: this.userRoles == 'Student' ? [this.userInfo.facultyIds] : this.userInfo.facultyIds,
                studyCourseIds: this.userRoles == 'Student' ? [this.userInfo.studyCourseIds] : this.userInfo.studyCourseIds
            })
                .then(() => {
                    this.loading = false;

                    this.snackbar = {
                        text: 'Данные успешно сохранены.',
                        color: 'success',
                        timeout: 5000,
                        show: true
                    };
                }, () => {
                    this.loading = false;

                    this.snackbar = {
                        text: 'Произошла ошибка. Данные не были сохранены.',
                        color: 'error',
                        timeout: -1,
                        show: true
                    };
                });
        },
        validateEmail(input) {
            if (input.value !== null && input.value.length > 0) {
                if (!input.value.includes('@')) {
                    input.setCustomValidity('Нет символа @');
                } else if (input.value.startsWith('@') || input.value.endsWith('@')) {
                    input.setCustomValidity('Неверный e-mail');
                } else {
                    input.setCustomValidity('');
                }
            }
        },
        validateInput(input) {
            let message = input.value === null || input.value.length === 0 ? 'Обязательно для заполнения' : '';
            input.setCustomValidity(message);
        },
        getCourse() {
            this.$http.get(`${this.apiUrl}api/SprStudyCourse/GetAll`)
                .then((response) => {
                    this.studyCourseList = response.data;
                });
        }
    },
    created() {
        // console.log(this.userRoles);
		this.getUserInfo();
        this.getCourse();
        this.loadLookups();
	}
}
</script>
